import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { parseFormData } from "../../utils/parseFormData";


export const hospitalAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    const updates = parseFormData(formData);
    if (params.id === "new")
        await axiosApi.post("/api/hospitals", updates);
    else await axiosApi.put("/api/hospitals", { ...updates, id: params.id });
    return redirect(`/hospitals`);
}